import { Table, TableContainer } from '@mui/material';
import { useState } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import MessagePostGridHead from './messageGridHead.component';
import MessagePostGridBody from './messageGridBody.component';
import MessageGridPagination from './messageGridPagination';

const MessagePostGrid = ({
  connectedProfileId,
  crmList,
  handleReCallCRM,
  handleTypeFilter,
  serviceName,
  order,
  orderBy,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  handleStatusChange,
  selectedType,
}) => {
  const [searchText, setSearchText] = useState('');

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';
    handleReCallCRM(newOrder, property, searchText);
  };

  const handleSearch = (search) => {
    setSearchText(search);
    handleReCallCRM(order, orderBy, search);
  };

  return (
    <>
      <DynamicHeightComponent>
        <Scrollbar>
          <TableContainer sx={{ maxHeight: 'calc(100vh - 305px)', minHeight: 'calc(100vh - 305px)' }}>
            <Table stickyHeader size="small">
              <MessagePostGridHead
                handleRequestSort={handleRequestSort}
                handleTypeFilter={handleTypeFilter}
                order={order}
                orderBy={orderBy}
                serviceName={serviceName}
                selectedType={selectedType}
              />
              <MessagePostGridBody
                connectedProfileId={connectedProfileId}
                crmList={crmList}
                page={page}
                rowsPerPage={rowsPerPage}
                serviceName={serviceName}
                selectedType={selectedType}
                handleStatusChange={handleStatusChange}
              />
            </Table>
          </TableContainer>
          <MessageGridPagination
            totalCount={totalCount}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
          />
        </Scrollbar>
      </DynamicHeightComponent>
    </>
  );
};

export default MessagePostGrid;
